export default __webpack_public_path__ + "static/media/Home-section-4.162b63e8.png";